exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ":host{display:flex;width:100%;background-color:#f3f2ed}:host .row{display:flex;justify-content:space-between;align-items:center}:host .row,:host .row>*{padding:.5rem}:host .row .title-block{display:flex;flex-direction:column}:host .row .title-block .title{font-weight:700;font-size:1.2rem;color:#191919}:host .row .title-block .sub-title{font-size:1.1rem;color:#191919}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["./~/bootstrap/scss/_functions.scss","./~/bootstrap/scss/_variables.scss","./src/main/webapp/content/scss/variables.scss"]}!./src/main/webapp/app/depot-requete/steps/requerants/add-requerant-section/add-requerant-header/add-requerant-header.component.scss
// module id = 675
// module chunks = 0